import React, {
  forwardRef,
  memo,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import {
  AppBar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Stack,
  Icon,
  IconButton,
  TextField,
  Toolbar,
  Typography,
  Checkbox,
  Tooltip,
  Switch,
  Alert,
  AlertTitle,
  LinearProgress,
} from "@mui/material";
import clsx from "clsx";
import { makeStyles, styled } from "@mui/styles";
import {
  DateFromEditorComponent,
  DateToEditorComponent,
} from "../../discount-master/DatepickerEditorComponent";
import jwtDecode from "jwt-decode";
import dayjs from "dayjs";
import AgGridTable from "../../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import ListPageHeader from "../../utilities/ListPageHeader";
import { confirmAlert } from "react-confirm-alert";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { toast } from "react-toastify";
import AsyncSelect from "react-select/async";
import moment from "moment";
import CustomDatePicker from "../../utilities/CustomDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { useNavigate } from "react-router-dom";
import "./expenseClaim.css";
import FormPageHeader from "../../utilities/FormPageHeader";
import handleFileName from "./DocumentUpload";
import LocationCellRenderer from "./locationCellRenderer";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& input": {
    padding: "10px 14px",
  },
}));

const UploadButton = styled(Button)(({ theme }) => ({
  fontSize: 11,
  color: "#fff !important",
  background: `${theme.palette.primary.main}`,
  borderRadius: 20,
  padding: "5px 10px",
  cursor: "pointer",
}));

const financeYearUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.financeYear}`;
const countryListUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.country}`;
const token = localStorage.getItem("token") && jwtDecode(localStorage.getItem("token"));
const currentDate = new Date();

const Upload = (params) => {
  const uploadUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.fileUpload}`;
  const downloadUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.fileDownload}`;

  const downloadFile = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.downloadFile}`;
  const downloadPath = `${downloadFile}/${params.data?.fileUrl}?path=${params.data?.uploadWinnerPath}`;

  const hiddenFileInput = useRef();
  const [winner, setWinner] = useState({
    name: params.node.data.fileUrl,
  });
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  async function remove() {
    params.node.data.fileUrl = "";
    setWinner(null);
  }

  function uploadProgressChanged(params){
    const { progress } = params;
    setUploadProgress(progress * 100);
  }
  const onChange = async (e) => {
    const fileUploaded = e.target.files[0];
    setUploading(true);
    // if (!fileUploaded) return;
    const formData = new FormData();
    formData.append("file", fileUploaded);
    const response = await OAuthService.uploadFile(uploadUrl, formData);
    toast.success("Upload Successfully");
    params.node.updateData(response.data);
    setWinner(fileUploaded);
    setUploading(false);
    setUploadProgress(0);
  };

  const downloadFiles = async () => {
    const blob = await fetch(fileDownload, OAuthService.config()).then((resp) =>
      resp.blob()
    );
    const objUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objUrl;
    a.download = params.node?.data?.fileUrl;
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(objUrl);
    document.body.removeChild(a);
  };

  return uploading ? <Box sx={{ display: 'flex', alignItems: 'center' }}>
     <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" value={uploadProgress} /> 
     </Box>
     <Box sx={{ minWidth: 35 }}>
     <Typography variant="body2" color="text.secondary">
      {Math.round(uploadProgress)}%
     </Typography>
     </Box>
    </Box> :
  <span>
      {!params.node.data.fileUrl && (
        <UploadButton
          variant="contained"
          component="label"
          fullWidth
          color="primary"
          ref={hiddenFileInput}
          onChange={onChange}
        >
          UPLOAD WINNER
          <input type="file" hidden />
        </UploadButton>
      )}
      {winner && (
        <>
          <Button
            variant="outlined"
            size="small"
            onClick={downloadFiles}
            startIcon={<FuseSvgIcon>heroicons-outline:download</FuseSvgIcon>}
          >
            Download
          </Button>
          <IconButton onClick={remove}>
            <FuseSvgIcon>heroicons-outline:x</FuseSvgIcon>
          </IconButton>
        </>
      )}
    </span>
};

export default function ExpenseClaimAdd(props) {
  const navigate = useNavigate();

  const { open, handleClose } = props;
  const [rowData, setRowData] = useState([
    {
      fromDate: "",
      toDate: "",
      days: 0,
      hours: 0,
      location: "",
      purpose: "",
      subLedgerCode: "",
      subLedgerName: "",
      amount: 0,
      maxAmount: 0,
      fileUrl: "",
      isApproved: false,
    },
  ]);
  const [error, setError] = useState();
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const gridRef = useRef();
  const [addedRows, setAddedRows] = useState([]);

  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [totalClaimed, setTotalClaimed] = useState();
  const [folderName, setFolderName] = useState();
  const [folderDescription, setFolderDescription] = useState();
  const [count, setCount] = useState(0);
  
  
  
  const [docUpdate, setDocUpdate] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  const [checkPosting, setCheckPosting] = useState();
  const [saveDisable, setSaveDisable] = useState(true)
  const [initialState, setInitialState] = useState({
    docNo: null,
    docDate: currentDate,
    creationDate: new Date().toISOString(),
    employeeId: null,
    employeeName: null,
    companyCode: 1,
    companyName: "Nolte FZE",
    currency: "EUR",
    remark: null,
    financeDoc: "string",
    recordList: [],
  });
  
  const currencyOption = [
    { label: "AED", value: "AED" },
    { label: "EUR", value: "EUR" },
    // { label: "USD", value: "USD" },
    // { label: "(OTHER)", value: "(OTHER)" },
  ];

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const token = localStorage.getItem("token") && jwtDecode(localStorage.getItem("token"));

  // const ApprovedCheckboxRenderer = (props) => {
  //   const queryString = window.location.search;
  //   const urlParams = new URLSearchParams(queryString);

  //   return (
  //     <Checkbox
  //       sx={{ padding: "0px !important" }}
  //       size="small"
  //       defaultChecked={props?.data?.isApproved}
  //       onChange={async (e) => {
  //         props.data.approvedAmount =
  //           e.target.checked === true ? props.data.amount : 0;
  //         props.data.isApproved = e.target.checked;
  //         setCount(count + 1);
  //         props.node.setData(props.data);
  //       }}
  //       disabled={
  //         urlParams.size === 0
  //           ? true
  //           : token?.scope?.includes("ROLE_FINANCE") === true
  //           ? false
  //           : token?.scope?.includes("ROLE_FINMGR") === true
  //           ? false
  //           : true
  //       }
  //     />
  //   );
  // };

  const ApprovedIconComponent=(props)=> {
    // const queryString = window.location.search;
    // const urlParams = new URLSearchParams(queryString);

    let bool = props?.data?.isApproved
    return (
      <Switch
        size="small"
        defaultChecked={bool}
        onChange={async (e) => {
          props.data.approvedAmount =
            e.target.checked === true ? props.data.amount : 0;
          props.data.isApproved = e.target.checked;
          setCount(count + 1);
          props.node.setData(props.data);
        }}
        disabled={
          urlParams.size === 0
            ? true
            : token?.scope?.includes("ROLE_FINANCE") === true
            ? false
            : token?.scope?.includes("ROLE_FINMGR") === true
            ? false
            : true
        }
      />
    );
  }

  const SelectFromDatePicker = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refExpenseConfig = useRef();
    const [error, setError] = useState("");
    const [value, setValue] = useState(null);

    const getConfigData = async () => {};

    const getCurrentMonthStartDate = (date) => {
      return new Date(date.getFullYear(), date.getMonth() - 1, 1);
    };
  
    const getNextMonthEndDate = (date) => {
      return new Date(date.getFullYear(), date.getMonth() + 2, 0);
    };

    useEffect(() => {
      getConfigData();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        {/* <LocalizationProvider dateAdapter={AdapterDayjs}> */}
          <DateTimePicker
            name="Controlled"
            value={value}
            format="DD/MM/YYYY hh:mm a"
            ref={refExpenseConfig}
            onChange={(newValue) => {
              setValue(newValue);
            }}
            styles={customStyles()}
            className="customDatePickerDiscount w-[170px]"
            minDate={getCurrentMonthStartDate(new Date())}
            maxDate={getNextMonthEndDate(new Date())}
          />
        {/* </LocalizationProvider> */}
      </div>
    );
  });

  const SelectToDatePicker = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refExpenseConfig = useRef();
    const [error, setError] = useState("");
    const [value, setValue] = useState(null);
    const getConfigData = async () => {};

    const handleChange = async (value) => {
      if (!value) return;
      setValue(value);
      console.log('value', value, data.fromDate, data.toDate)
      const toDate = data.toDate ? data.toDate : value
      const startDate = moment(data.fromDate);
      const endDate = moment(toDate);

      console.log('startDate', startDate)
      console.log('endDate', endDate)

      if(startDate.isValid() && endDate.isValid()) {
        const timeDifference = endDate - startDate;
        const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        const hoursDifference = Math.floor(
          (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        console.log('daysDifference', daysDifference)
        console.log('hoursDifference', hoursDifference)
        data.days = daysDifference;
        data.hours = hoursDifference;
        props.node.setData(data);
        
      } else {
        console.error('Invalid date format');
      }
    };

    const getNextMonthEndDate = (date) => {
      return new Date(date.getFullYear(), date.getMonth() + 2, 0);
    };

    useEffect(() => {
      getConfigData();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        {/* <LocalizationProvider dateAdapter={AdapterDayjs}> */}
          <DateTimePicker
            name="Controlled"
            value={value}
            format="DD/MM/YYYY hh:mm a"
            ref={refExpenseConfig}
            onChange={handleChange}
            styles={customStyles()}
            className="customDatePickerDiscount w-[170px]"
            minDate={new Date(data.fromDate)}
            maxDate={getNextMonthEndDate(new Date(data.fromDate))}
          />
        {/* </LocalizationProvider> */}
      </div>
    );
  });

  const SelectExpenseType = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refExpenseConfig = useRef();
    const [error, setError] = useState("");
    const [expenseConfig, setExpenseConfig] = useState([]);
    const [selectedConfig, setSelectedConfig] = useState(null);
    let code = data.location.substring(0, 2);
    const claimConfig = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.expenseClaimConfig}/search/findByCountryCode?code=${code}`;

    const getConfigData = async () => {
      const configResult = await OAuthService.getList(claimConfig);

      const configData = configResult?.data?._embedded?.expenseClaimConfigs;

      setExpenseConfig(
        configData?.map((item) => ({
          label: item.subLedgerCode,
          value: item.subLedgerCode,
          subLedgerName: item.subLedgerName,
          maxAmount: item.maxAmount,
        }))
      );
    };

    const handleCountryChange = async (value) => {
      if (!value) return;
      data.subLedgerName = value.subLedgerName;
      data.maxAmount = value.maxAmount;
      props.node.setData(data);
      setSelectedConfig(value);
    };

    useEffect(() => {
      getConfigData();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedConfig?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refExpenseConfig}
          value={selectedConfig}
          onChange={handleCountryChange}
          options={expenseConfig}
          styles={customStyles()}
        />
      </div>
    );
  });

  const SelectLocation = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refLocation = useRef();
    const [error, setError] = useState("");
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    
    const getCountryList = async () => {
      try {
      const dataList = await OAuthService.getList(
        countryListUrl + `?sort=name,asc&size=1000`
      );
      const data = dataList?.data?._embedded?.countries;
      setCountries(data)
      } catch (error) {
        console.error('Error fetching country list:', error);
      }
    };    

    const handleCountryChange = async (value) => {
      if (!value) return;
      console.log('value', value)
      setSelectedCountry(value);
      // props.node.setData(data);
      props.node.setDataValue("location", value.value);
      // setOpenCom(false);
    };

    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        event.preventDefault(); // Prevent the default behavior
        props.api.stopEditing(); // Stop editing after pressing Enter
      }
    };

    useEffect(() => {
      getCountryList();
      
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedCountry?.label;
        },
      };
    });

    // useEffect(() => {
    //   props.api.addEventListener("cellKeyDown", handleGridEvents);
    //   return () => {
    //     props.api.removeEventListener("cellKeyDown", handleGridEvents);
    //   };
    // }, [props.api]);

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refLocation}
          value={selectedCountry}
          onChange={handleCountryChange}
          onKeyDown={handleKeyDown}
          options={countries}
          styles={customStyles()}
        />
      </div>
    );
  });

  const handleDateFormat = (props) => {
    return props.value && moment(props.value).format("DD-MM-YYYY hh:mm a");
  };

  const handleDays = (props) => {
    const { data, colDef } = props;
    const date1 = new Date(data.fromDate);
    const date2 = new Date(data.toDate);

    const difference = date2.getTime() - date1.getTime();
    const daysDifference = difference / (1000 * 3600 * 24);
    let totalDays = Math.abs(daysDifference);

    return totalDays.toString() === "NaN" ? 0 : totalDays;
  };

  // const handleFileName = (props) => {
  //   return (
  //     // <Button
  //     //   variant="contained"
  //     //   color="primary"
  //     //   onClick={() => {
  //     //     handleAddDoc(props.data, props.rowIndex);
  //     //   }}
  //     //   size="small"
  //     // >
  //     //   Upload{" "}
  //     // </Button>
  //     <IconButton onClick={() => handleAddDoc(props.data, props.rowIndex)}>
  //       <FuseSvgIcon size={12} color="primary">heroicons-outline:upload</FuseSvgIcon>
  //     </IconButton>
  //   );
  // };

  // const shouldHideColumn = () => {
  //   console.log('docUpdate', docUpdate)
  //   return docUpdate ? true : false;
  // };

  const [columnDefs, setColumnDefs] = useState([
    {
      field: "fromDate",
      type: "editableColumn",
      headerName: "From Date",
      cellEditor: SelectFromDatePicker,
      cellRenderer: handleDateFormat,
      minWidth: 175,
    },
    {
      field: "toDate",
      type: "editableColumn",
      headerName: "To Date",
      cellEditor: SelectToDatePicker,
      cellRenderer: handleDateFormat,
      minWidth: 175,
    },
    {
      field: "days",
      headerName: "Days",
      editable: false,
      minWidth: 100,
    },
    {
      field: "hours",
      headerName: "Hours",
      editable: false,
      minWidth: 100,
    },
    // {
    //   headerName: 'Location',
    //   field: 'location',
    //   // cellRenderer: LocationCellRenderer,
    //   cellEditor: 'reactSelectEditor',
    //   minWidth: 100,
    //   // cellEditorPopup: true,
    //   cellEditor: ReactSelectEditor,
    //   cellEditorParams: {
    //     options: countries?.map(item => item.name) || [],
    //     // component: CustomSelectComponent,
    //     // reactSelectProps: {
    //     //   // Props passed directly to react-select
    //     //   isMulti: false, // Set to true if you want to allow multiple selections
    //     // },
    //     // cellRenderer: LocationCellRenderer,
    //     // searchType: 'match',
    //     // allowTyping: true,
    //     // valueListMaxHeight: 220,
    //   },
    // },
    {
      field: "location",
      headerName: "Location",
      minWidth: 100,
      cellEditorPopup: true,
      cellEditor: "agSelectCellEditor",
      cellEditor: SelectLocation,
    },
    {
      field: "purpose",
      headerName: "Purpose",
      minWidth: 100,
    },
    {
      field: "subLedgerCode",
      headerName: "Expense Type",
      minWidth: 100,
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectExpenseType,
    },
    {
      field: "subLedgerName",
      headerName: "Expense",
      editable: false,
      minWidth: 100,
    },
    {
      field: "amount",
      headerName: "Amount",
      minWidth: 100,
    },
    {
      field: "maxAmount",
      headerName: "Max Amount",
      editable: false,
      minWidth: 100,
    },
    {
      field: "isApproved",
      headerName: "Approved?",
        editable: false,
      minWidth: 100,
      cellRenderer: ApprovedIconComponent,
      hide: urlParams.get("id") === null ? true : false,
    },
    {
      field: "approvedAmount",
      headerName: "Approved Amount",
      editable: false,
      minWidth: 100,
      hide: urlParams.get("id") === null ? true : false,
    },
    {
      field: "fileUrl",
      headerName: "Documents",
      minWidth: 100,
      cellEditor: Upload,
    },
  ])
  
  const loadData = async () => {
    let email = token?.email;
    const userDataUrl = `${process.env.REACT_APP_HR_API_KEY_URL}api/hr/employees/search/findEmployeeByEmail?email=${email}`;
    const result = await OAuthService.getList(userDataUrl);
    // const user = result?.data;

    setInitialState({
      ...initialState,
      employeeName: `${result?.data?.empFirstName} ${result?.data?.empMiddleName} ${result?.data?.empLastName}`,
      employeeId: result?.data?.employeeId,
      companyName: result?.data?.companyName,
      companyCode: result?.data?.companyId,
      remark: `0${result?.data?.employeeId}_${result?.data?.empFirstName} ${
        result?.data?.empMiddleName
      } ${result?.data?.empLastName} Expense Claim ${moment(
        new Date().toISOString()
      ).format("MMM YYYY")}`,
    });

    setDocUpdate(urlParams.get("id") === null ? false : true);
    setViewMode(urlParams.get("view") === "true" ? true : false);

    if (urlParams.get("id") !== null) {
      const dataUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${
        oAuthServiceConfig.expenseClaimList
      }/${urlParams.get("id")}`;

      const dataVal = await OAuthService.getList(dataUrl);
      let amount = dataVal?.data?.recordList?.map((item) => {
        return item.amount;
      });
      setTotalClaimed(amount);
      setInitialState(dataVal.data);
      setRowData(dataVal.data.recordList);
      setAddedRows(dataVal.data.recordList);
    }
  };

  const onGridReady = useCallback((params) => {
    global.gridApi = params.api;
  }, []);

  useEffect(() => {
    loadData();
  }, [])

  const onBtAdd = useCallback(
    (event) => {
      let newRow = {
        fromDate: "",
        toDate: "",
        days: 0,
        hours: 0,
        location: "",
        purpose: "",
        subLedgerCode: "",
        subLedgerName: "",
        amount: 0,
        maxAmount: 0,
        fileUrl: "",
        isApproved: false,
      };
      const RowIndex = event.node;

      rowData && rowData?.splice(RowIndex, 0, newRow);
      gridRef.current.api.applyTransaction({
        add: [newRow],
        addIndex: RowIndex,
      });
      gridRef.current.api.refreshCells();
      setTimeout(() => {
        gridRef.current.api.setFocusedCell(RowIndex, "fromDate");
        gridRef.current.api.startEditingCell({
          rowIndex: RowIndex,
          colKey: "fromDate",
        });
      }, 800);
    },
    [rowData]
  );

  const onBtCopyRow = useCallback((event) => {
    const data = event.node.data;
    const copyRow = {
        fromDate: data.fromDate,
        toDate: data.toDate,
        days: data.days,
        hours: data.hours,
        location: data.location,
        purpose: data.purpose,
        subLedgerCode: data.subLedgerCode,
        subLedgerName: data.subLedgerName,
        amount: data.amount,
        maxAmount: data.maxAmount,
    }
    const newRowDate = gridRef.current.api.applyTransaction({ add: [copyRow] });
    const RowIndex = newRowDate.add[0].rowIndex;
    rowData.splice(RowIndex, 0, copyRow);
    gridRef.current.api.refreshCells();

    setTimeout(() => {
        gridRef.current.api.setFocusedCell(RowIndex, 'fromDate')
        gridRef.current.api.startEditingCell({
            rowIndex: RowIndex,
            colKey: 'fromDate',
        });
    }, 800);
  }, [rowData]);

  const onBtDeleteRow = useCallback(
    (event) => {
      const selectedRow = [event.node.data];

      confirmAlert({
        title: "Confirm to delete",
        message: "Are you sure to delete.",
        buttons: [
          {
            label: "Yes",
            onClick: () => {
              rowData?.splice(event.node.rowIndex, 1);
              gridRef?.current?.api.applyTransaction({ remove: selectedRow });
              selectedRow.map(async (row) => {
                setSuccessMsg("Data deleted Successfully");
                setSnackState(true);
              });
            },
          },
          {
            label: "No",
            onClick: () => {},
          },
        ],
      });
    },
    [gridRef, rowData]
  );

  const getContextMenuItems = useCallback((event) => {
    const result = [
      {
        name: "Add",
        icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
        action: () => {
          onBtAdd(event);
        },
      },
      {
        name: "Copy Row",
        // disabled: data ? false : true,
        icon: '<span><i class="material-icons" style="font-size: 18px">copy</i></span>',
        action: () => {
            onBtCopyRow(event);
        },
      },
      {
        name: "Delete",
        icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
        action: () => {
          onBtDeleteRow(event);
        },
      },
    ];
    return result;
  }, []);

  const onRowValueChanged = async (event) => {
    const { rowIndex, data } = event.node;
    const tempAddedRows = [...addedRows];
    tempAddedRows[rowIndex] = data;
    setAddedRows(tempAddedRows);
  };

  const handleEditClaim = async (props) => {
    const mainApproved = rowData?.filter((item) => item.isApproved === false);

    let body =
      rowData.length === 0
        ? {
            ...initialState,
            docDate:
              initialState.docDate === null
                ? moment(currentDate).format("YYYY-MM-DD")
                : moment(initialState.docDate).format("YYYY-MM-DD"),
            isApproved: mainApproved.length > 0 ? false : true,
          }
        : {
            ...initialState,
            recordList: rowData,
            docDate:
              initialState.docDate === null
                ? moment(currentDate).format("YYYY-MM-DD")
                : moment(initialState.docDate).format("YYYY-MM-DD"),
            isApproved: mainApproved.length > 0 ? false : true,
          };

    // const queryString = window.location.search;
    // const urlParams = new URLSearchParams(queryString);

    setDocUpdate(urlParams.get("id") === null ? false : true);

    const dataUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${
      oAuthServiceConfig.expenseClaimList
    }/${urlParams.get("id")}`;

    OAuthService.putData(dataUrl, body)
      .then((resp) => {
        setSuccessMsg("Data Updated Successfully");
        setSnackState(true);
      })
      .catch((error) => setError(error.message));
  };

  const handleSubmit = async (props) => {
    let body = {
      ...initialState,
      recordList: addedRows,
      docDate:
        initialState.docDate === null
          ? moment(currentDate).format("YYYY-MM-DD")
          : moment(initialState.docDate).format("YYYY-MM-DD"),
      // employeeId: 2,
    };
    console.log('body', body)
    const addUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.expenseClaimList}`;
    OAuthService.addData(addUrl, body)
      .then(async (resp) => {
        resp.data.docNo.length > 0 ? setDocUpdate(true) : setDocUpdate(false);
        setSuccessMsg("Data Added Successfully");
        setSnackState(true);
        navigate("/expense-claim");
      })
      .catch((error) => setError(error.message));
  };

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "ExpenseClaim.xlsx",
      sheetName: "Expense Claim",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  // const queryString = window.location.search;
  // const urlParams = new URLSearchParams(queryString);

  

  

  

  const postingCheck = async() => {
    const docDate = initialState.docDate === null ? moment(currentDate).format("YYYY-MM-DD") : moment(initialState.docDate).format("YYYY-MM-DD")
    console.log('docDate', docDate)
    const checkPostingDate = await OAuthService.getList(financeYearUrl+`/checkPostingAvailability?checkDate=${docDate}`);
    setCheckPosting(checkPostingDate?.data?.isPostingAllowed);
  }

  useEffect(() => {
      postingCheck()
  },[initialState])

  // const handleBack = () => {
  //   navigate("/expense-claim");
  // }

  return (
    <>
      {docUpdate ? (
        <FormPageHeader
          componentName=" Expense Claim"
          error={error}
          successMsg={successMsg}
          snackState={snackState}
          handleSubmit={handleEditClaim}
          saveDisable={saveDisable}
          // handleBack={handleBack}
        />
      ) : (
        <FormPageHeader
          componentName="Add Expense Claim"
          error={error}
          successMsg={successMsg}
          snackState={snackState}
          handleSubmit={handleSubmit}
          saveDisable={saveDisable}
          // handleBack={handleBack}
        />
      )}
      <div className="p-4 sm:px-24">
        {checkPosting === false && <Alert severity="error" className="mb-16">
            <AlertTitle>Error</AlertTitle>
            {`Voucher posting for Doc. Date '${moment(initialState.docDate).format('DD-MM-YYYY')}' is not allowed as financial year for desire period is not defined into the system`}
        </Alert>}
        <Grid container spacing={2} className="pb-6">
          <Grid xs={16} item>
            <Stack direction="row" spacing={2} style={{ alignItems: "center" }}>
              {docUpdate && (
                <Stack>
                  <span>Doc Number</span>
                  <TextField
                    className="mb-4 w-[100px]"
                    type="text"
                    required
                    variant="outlined"
                    fullWidth
                    value={urlParams.get("doc")}
                    disabled
                  />
                </Stack>
              )}
              <Stack>
                <span>Doc Date</span>
                <CustomDatePicker
                  disabled={viewMode}
                  className="mb-4 w-[130px]"
                  format={"dd-MM-yyyy"}
                  name={"fromDate"}
                  value={
                    initialState.docDate === null
                      ? moment(currentDate, "DD/MM/YYYY").format(
                          "ddd MMM DD YYYY 00:00:00 [GMT]ZZ [(]z[)]"
                        )
                      : initialState.docDate
                  }
                  handleChange={(date) => {
                    setInitialState({
                      ...initialState,
                      docDate: date,
                    });
                  }}
                />
              </Stack>
              
              <Stack>
                <span>EMP ID / Name</span>
                <Stack direction="row" spacing={1}>
                  <TextField
                    className="mb-4 w-[75px] "
                    type="text"
                    variant="outlined"
                    fullWidth
                    value={initialState?.employeeId}
                    disabled
                  />
                  <TextField
                    className="mb-4 "
                    type="text"
                    variant="outlined"
                    fullWidth
                    value={initialState?.employeeName}
                    disabled
                  />
                </Stack>
              </Stack>
              {docUpdate && (
                <>
                <Stack>
                  <span>Company</span>
                  <Stack direction="row" spacing={1}>
                    <TextField
                      className="mb-4 w-[75px] "
                      type="text"
                      variant="outlined"
                      fullWidth
                      // value={initialState?.employeeId}
                      disabled
                    />
                    <TextField
                      className="mb-4 "
                      type="text"
                      variant="outlined"
                      fullWidth
                      // value={initialState?.employeeName}
                      disabled
                    />
                  </Stack>
                </Stack>
                <Stack>
                  <span>Department</span>
                  <Stack direction="row" spacing={1}>
                    <TextField
                      className="mb-4 w-[75px] "
                      type="text"
                      variant="outlined"
                      fullWidth
                      // value={initialState?.employeeId}
                      disabled
                    />
                    <TextField
                      className="mb-4 "
                      type="text"
                      variant="outlined"
                      fullWidth
                      // value={initialState?.employeeName}
                      disabled
                    />
                  </Stack>
                </Stack>
                <Stack>
                  <span>Designation</span>
                  <Stack direction="row" spacing={1}>
                    <TextField
                      className="mb-4 w-[75px] "
                      type="text"
                      variant="outlined"
                      fullWidth
                      // value={initialState?.employeeId}
                      disabled
                    />
                    <TextField
                      className="mb-4 "
                      type="text"
                      variant="outlined"
                      fullWidth
                      // value={initialState?.employeeName}
                      disabled
                    />
                  </Stack>
                </Stack>
                <Stack>
                  <span>Creation Date</span>
                  <CustomDatePicker
                    className="mb-4 w-[130px]"
                    name={"creationDate"}
                    format={"dd-MM-yyyy"}
                    fullWidth
                    value={initialState.creationDate}
                    //   value={employeeId}
                    disabled={viewMode}
                  />
                </Stack>
                </>
              )}
              <Stack>
                <span>Currency</span>
                <Select
                  name="currency"
                  placeholder="Currency"
                  defaultValue={{
                    value: initialState?.currency,
                    label: initialState?.currency,
                  }}
                  //   value={{
                  //     value: initialState?.currency,
                  //     label: initialState?.currency,
                  //   }}
                  onChange={(val) => {
                    setInitialState({
                      ...initialState,
                      currency: val.value,
                    });
                  }}
                  options={currencyOption}
                  styles={customStyles()}
                  disabled={viewMode}
                />
              </Stack>
              <Stack>
                <span>Remarks</span>
                <TextField
                  className="mb-4"
                  type="text"
                  required
                  variant="outlined"
                  disabled={viewMode}
                  value={initialState.remark}
                  onChange={(val) => {
                    setInitialState({
                      ...initialState,
                      remark: val.target.value,
                    });
                  }}
                  fullWidth
                />
              </Stack>
              {/* <Stack>
                <Button
                  color="warning"
                  variant="contained"
                  onClick={() => {
                    setCheckedAll(true);
                  }}
                >
                  Approve All
                </Button>
              </Stack> */}
              {/* <Stack xs={10}>
                {" "}
                <Button
                  variant="contained"
                  color="warning"
                  style={{ marginBottom: "5px", fontWeight: "bold" }}
                  onClick={() => {
                    navigate(
                      `/expense-claim/docUpload?id=${urlParams.get("id")}`
                    );
                  }}
                >
                  <FuseSvgIcon>heroicons-solid:upload</FuseSvgIcon>
                </Button>
              </Stack> */}
            </Stack>
          </Grid>
        </Grid>
      </div>

      <div className="h-full w-full">
        <AgGridTable
          tableClassName={"expense-claim"}
          hideCheckbox={true}
          rowData={rowData}
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          gridRef={gridRef}
          getContextMenuItems={getContextMenuItems}
          successMsg={successMsg}
          snackState={snackState}
          //   rowSelection={"multiple"}
          rowGroupPanelShow="never"
          editable={urlParams.get("view") ? false : true}
          onCellValueChanged={onRowValueChanged}
          // onRowDoubleClicked={}
          //editType={"fullRow"}
        />
      </div>
      <Grid
        className="flex flex-row mb-10"
        justifyContent="flex-end"
        alignItems="flex-end"
        style={{ background: "grey" }}
      >
        <div
          style={{
            fontSize: "16px",
            color: "white",
          }}
          className="p-8"
        >
          Total Amount Claimed:
        </div>
        <div
          style={{
            fontSize: "20px",
            color: "white",
            minWidth: "5vw",
          }}
          className="p-8"
        >
          {rowData
            ?.map((item) => {
              return parseInt(item.amount);
            })
            ?.reduce((total, num) => parseInt(total) + parseInt(num), 0)}
        </div>
      </Grid>

      {urlParams.get("approved") === "true" && (
        <>
          <Grid container>
            <Grid xs={12} item>
              <div className="p-12">APPROVED EXPENSES</div>
              <Grid container spacing={2} className="p-12">
                <Grid xs={6} item>
                  <Stack direction={"row"} spacing={2}>
                    <Stack>
                      <div className="pb-5">AIR TRAVEL</div>

                      <TextField
                        className="mb-4 w-[180px]"
                        type="text"
                        required
                        variant="outlined"
                        fullWidth
                        disabled
                      />
                    </Stack>
                    <Stack>
                      <div className="pb-5">HOTEL</div>

                      <TextField
                        className="mb-4 w-[180px]"
                        type="text"
                        required
                        variant="outlined"
                        fullWidth
                        disabled
                      />
                    </Stack>
                    <Stack>
                      <div className="pb-5">DAILY ALLOWANCE</div>

                      <TextField
                        className="mb-4 w-[180px]"
                        type="text"
                        required
                        variant="outlined"
                        fullWidth
                        disabled
                      />
                    </Stack>
                    <Stack>
                      <div className="pb-5">VISA EXPENSES</div>

                      <TextField
                        className="mb-4 w-[180px]"
                        type="text"
                        required
                        variant="outlined"
                        fullWidth
                        disabled
                      />
                    </Stack>
                    <Stack>
                      <div className="pb-5">INSURANCE EXPENSES</div>

                      <TextField
                        className="mb-4 w-[180px]"
                        type="text"
                        required
                        variant="outlined"
                        fullWidth
                        disabled
                      />
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
              <Grid container spacing={2} className="p-16">
                <Grid xs={6} item>
                  <Stack direction={"row"} spacing={2}>
                    <Stack>
                      <div className="pb-5">CLIENT WELFARE</div>

                      <TextField
                        className="mb-4 w-[180px]"
                        type="text"
                        required
                        variant="outlined"
                        fullWidth
                        disabled
                      />
                    </Stack>
                    <Stack>
                      <div className="pb-5">RENT A CAR</div>

                      <TextField
                        className="mb-4 w-[180px]"
                        type="text"
                        required
                        variant="outlined"
                        fullWidth
                        disabled
                      />
                    </Stack>
                    <Stack>
                      <div className="pb-5">PETROL/TAXI CHARGES</div>

                      <TextField
                        className="mb-4 w-[180px]"
                        type="text"
                        required
                        variant="outlined"
                        fullWidth
                        disabled
                      />
                    </Stack>
                    <Stack>
                      <div className="pb-5">REFRESHMENT EXP</div>

                      <TextField
                        className="mb-4 w-[180px]"
                        type="text"
                        required
                        variant="outlined"
                        fullWidth
                        disabled
                      />
                    </Stack>
                    <Stack>
                      <div className="pb-5">COMMUNICATION</div>

                      <TextField
                        className="mb-4 w-[180px]"
                        type="text"
                        required
                        variant="outlined"
                        fullWidth
                        disabled
                      />
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
              <Grid container spacing={2} className="p-16">
                <Grid xs={6} item>
                  <Stack direction={"row"} spacing={2}>
                    <Stack>
                      <div className="pb-5">MOBILE</div>

                      <TextField
                        className="mb-4 w-[180px]"
                        type="text"
                        required
                        variant="outlined"
                        fullWidth
                        disabled
                      />
                    </Stack>
                    <Stack>
                      <div className="pb-5">PARKING</div>

                      <TextField
                        className="mb-4 w-[180px]"
                        type="text"
                        required
                        variant="outlined"
                        fullWidth
                        disabled
                      />
                    </Stack>
                    <Stack>
                      <div className="pb-5">MARKETING</div>

                      <TextField
                        className="mb-4 w-[180px]"
                        type="text"
                        required
                        variant="outlined"
                        fullWidth
                        disabled
                      />
                    </Stack>
                    <Stack>
                      <div className="pb-5">TRAINING</div>

                      <TextField
                        className="mb-4 w-[180px]"
                        type="text"
                        required
                        variant="outlined"
                        fullWidth
                        disabled
                      />
                    </Stack>
                    <Stack>
                      <div className="pb-5">MISCELLENOUS</div>

                      <TextField
                        className="mb-4 w-[180px]"
                        type="text"
                        required
                        variant="outlined"
                        fullWidth
                        disabled
                      />
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            className="flex flex-row mb-10"
            justifyContent="flex-end"
            alignItems="flex-end"
            style={{ background: "grey" }}
          >
            <div
              style={{
                fontSize: "16px",

                color: "white",
              }}
              className="p-8"
            >
              Total Approved Cost:
            </div>
          </Grid>
        </>
      )}
    </>
  );
}
